export default {
    props: {
        errors: {
            type: Object | Array,
            default: null,
        },
    },
    methods: {
        hasError(inputName) {
            return this.errors && this.errors[inputName] !== undefined && this.errors[inputName].length > 0;
        },
        getError(inputName) {
            return this.errors && this.errors[inputName] !== undefined ? this.errors[inputName][0] : "";
        },
        getErrors(inputName) {
            return this.errors && this.errors[inputName] !== undefined ? this.errors[inputName] : [];
        },
    },
};
